import { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import FormRow from "./FormRow";

const FormSection = forwardRef(({ section, tab }, ref) => {
  const { scsHasHeading, scsDescription, fields, fieldInit, scsName } = section;
  const [sectionState, setSectionState] = useState(fieldInit);
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const sectionKey = useMemo(() => String(scsName), [scsName]);

  useImperativeHandle(
    ref,
    () => ({
      getKey: () => sectionKey,
      getState: () => sectionState,
      // setState: (update) => {
      //   setSectionState((prev) =>
      //     typeof update === "function" ? update(prev) : { ...prev, ...update },
      //   );
      // },
      reset: () => {
        setSectionState(fieldInit);
        setSearchFieldReset(true);
      },
    }),
    [fieldInit, sectionKey, sectionState],
  );

  return (
    <form className="ui form" style={{ paddingBottom: "80px" }}>
      {scsHasHeading && (
        <h4 className="ui dividing header">{scsDescription}</h4>
      )}
      {Object.entries(fields).map(([rowId, field]) => (
        <FormRow
          key={rowId}
          count={field.length}
          cols={field}
          section={section.scsId}
          tab={tab}
          sectionState={sectionState}
          setSectionState={setSectionState}
          searchFieldReset={searchFieldReset}
          setSearchFieldReset={setSearchFieldReset}
        />
      ))}
    </form>
  );
});

export default FormSection;
